import React from 'react';
import { Dumbbell, Zap } from 'lucide-react';
import GymVoucherCard from './GymVoucherCard';

// Static voucher data
const GYM_VOUCHERS = [
    { id: 'gym-300k', value: 300000, buyPrice: 325000, label: 'Gym Voucher Rp 300.000' },
    { id: 'gym-600k', value: 600000, buyPrice: 625000, label: 'Gym Voucher Rp 600.000' },
    { id: 'gym-1m', value: 1000000, buyPrice: 1025000, label: 'Gym Voucher Rp 1.000.000' },
    { id: 'gym-1.5m', value: 1500000, buyPrice: 1525000, label: 'Gym Voucher Rp 1.500.000' },
    { id: 'gym-2m', value: 2000000, buyPrice: 2025000, label: 'Gym Voucher Rp 2.000.000' },
];

const GymVoucherSection = () => {
    return (
        <div className="mb-10" data-testid="gym-voucher-section">
            {/* Section Header */}
            <div className="flex items-center justify-between mb-5">
                <h2 className="font-heading text-lg md:text-xl font-bold text-gray-900 flex items-center gap-2.5">
                    <div className="w-9 h-9 bg-gradient-to-br from-[#0a0a1a] to-[#1a1a2e] rounded-xl flex items-center justify-center shadow-md">
                        <Dumbbell className="w-5 h-5 text-[#AAFF00]" />
                    </div>
                    Gym Voucher
                    <span className="text-lg">💪</span>
                </h2>
                <span className="text-xs text-white bg-[#FF3B30] px-2.5 py-1 rounded-full font-semibold shadow-sm animate-pulse flex items-center gap-1">
                    <Zap className="w-3 h-3" />
                    Promo
                </span>
            </div>

            {/* Voucher Cards - Vertical Stack */}
            <div className="space-y-4">
                {GYM_VOUCHERS.map((voucher) => (
                    <GymVoucherCard key={voucher.id} voucher={voucher} />
                ))}
            </div>
        </div>
    );
};

export default GymVoucherSection;
